import React from 'react'
import { range } from 'ramda'
import 'less/controls/button.less'

const Spinner = () => (
  <span className="btn-loader-wrap">
    <span className="btn-loader">
      {range(0, 8).map(n => <span key={n} className={`circle circle-${n}`} />)}
    </span>
  </span>
)

const Button = ({
  children,
  className,
  disabled,
  /**
   * Boolean | undefined
   * Expected true | false when the button has loading behavior (ex: submitting a form)
   * The button will be disabled while true.
   * A spinner is mounted by default if not undefined, but will be hidden unless true.
   * This is an optimization for a smooth animation
   */
  isLoading,
  /**
   * Boolean
   * if true, shows a spinner when 'isLoading' is true
   * enabled by default if 'isLoading' is not undefined
   */
  enableSpinner = isLoading !== undefined,
  type = 'button',
  ...passThroughProps
}) => (
  <button
    type={type}
    className={
      [
        '_btn',
        'btn',
        className,
        disabled && 'disabled',
        isLoading && 'loading',
        enableSpinner && 'spinner-enabled',
      ]
      .filter(Boolean)
      .join(' ')
    }
    disabled={isLoading || disabled}
    {...passThroughProps}
  >
    <span className="btn-content">
      {children}
    </span>
    {enableSpinner && <Spinner />}
  </button>
)

export default Button
